import { post } from '../utils/http';
import { apiEndpoint, requestPayload } from '../utils/common';
import { API, ERRORS } from '../constant';
import { validateUpperCase } from '../utils/validations';

/**
 * Emi details based on channel code
 *
 * @param {string} channelCode - Bank channel code
 * @param {string | number} amount - amount for which emi details required
 * @returns {Promise<any>} - promise object contains response from server api
 */
export function emiDetails(channelCode, amount, emiType) {
  if (!validateUpperCase(channelCode)) {
    return Promise.reject(new Error(ERRORS.EMI));
  }

  const payload = { channelCode, emiType };
  if (amount !== undefined && amount !== null) {
    payload.amount = amount;
  }
  return post.call(this, apiEndpoint(API.EMI), requestPayload(payload));
}

/**
 * Bank List for EMI Subvention
 *
 * @param {Object} obj - EMI Subvention Payload
 * @returns {Promise<any>} - promise object contains response from server api
 */
export function emiSubventionBanks(obj) {
  return post.call(this, apiEndpoint(API.EMI_BANKS), requestPayload(obj));
}

/**
 * Emi details based on channel code for EMI Subvention
 *
 * @param {string} bankCode - Bank channel code
 * @param {string} cardType - Card Type
 * @param {Object} obj - EMI Subvention Payload
 * @returns {Promise<any>} - promise object contains response from server api
 */
export function emiSubventionPlans(bankCode, cardType, obj) {
  const payload = { ...obj };
  payload.filters = {
    bankCode,
    cardType
  };
  return post.call(this, apiEndpoint(API.EMI_TENURE), requestPayload(payload));
}

/**
 * Emi details based on channel code for EMI Subvention
 *
 * @param {Object} payload - Request Payload
 * @param {Object} obj - subvention object containing  items or price based on strategy
 * @returns {Promise<any>} - promise object contains response from server api
 */
export function emiSubventionValidatePlan(payload, obj) {
  const { paymentDetails, generateTokenForIntent, planId, customerId, cacheCardToken } = payload;
  obj.planId = planId;
  obj.paymentDetails = paymentDetails;
  obj.generateTokenForIntent = generateTokenForIntent;
  obj.customerId = customerId;
  obj.cacheCardToken = cacheCardToken;

  return post.call(this, apiEndpoint(API.EMI_VALIDATE), requestPayload(obj));
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/emi.js